module.exports = __webpack_public_path__ + "img/riskIconSum.c60bdc00.png";